import { Alert, Space } from "antd";
import type { OrderVo } from "@zhihaoscm/entity";
import { Button as ZhButton, Dialog as ZhDialog } from "zhihao-ui-react";

interface TradeOrderCancelSummary {
    pendingPaymentReceiveNum: number;
    pendingConfirmReceiveNum: number;
    toBeConfirmedDeliveryNum: number;
    confirmedDeliveryNum: number;
    total: number;
}

export interface TradeOrderCancelDialogProps {
    order: OrderVo | null;
    submitting?: boolean;
    errorMessage?: string | null;
    onCancel: () => void;
    onConfirm: () => void;
}

/** 计算 Vue 团购取消弹窗沿用的四类待处理数量，兼容历史大小写字段。 */
function getTradeOrderCancelSummary(row: OrderVo): TradeOrderCancelSummary {
    const target = row as OrderVo & { pendingConfirmReceiveNum?: number };
    const pendingPaymentReceiveNum = Number(target.pendingPaymentReceiveNum || 0);
    const pendingConfirmReceiveNum = Number(target.pendingConfirmReceiveNum ?? target.pendingconfirmReceiveNum ?? 0);
    const toBeConfirmedDeliveryNum = Number(target.toBeConfirmedDeliveryNum || 0);
    const confirmedDeliveryNum = Number(target.confirmedDeliveryNum || 0);
    return {
        pendingPaymentReceiveNum,
        pendingConfirmReceiveNum,
        toBeConfirmedDeliveryNum,
        confirmedDeliveryNum,
        total: pendingPaymentReceiveNum + pendingConfirmReceiveNum + toBeConfirmedDeliveryNum + confirmedDeliveryNum
    };
}

/** 交易订单列表和详情共用的 Vue 取消订单确认弹窗。 */
export function TradeOrderCancelDialog({
    order,
    submitting = false,
    errorMessage,
    onCancel,
    onConfirm
}: TradeOrderCancelDialogProps) {
    const summary = order ? getTradeOrderCancelSummary(order) : null;
    const isGroupBuyingOrder = order?.order?.orderType === 2;

    return (
        <ZhDialog
            open={order !== null}
            title="提示"
            width={500}
            onCancel={onCancel}
            footer={
                <Space>
                    <ZhButton disabled={submitting} onClick={onCancel}>
                        取消
                    </ZhButton>
                    <ZhButton loading={submitting} type="primary" onClick={onConfirm}>
                        确认
                    </ZhButton>
                </Space>
            }
        >
            {errorMessage ? <Alert className="mb-4" message={errorMessage} role="alert" type="error" /> : null}
            {isGroupBuyingOrder ? (
                <div>
                    <div>订单取消后，不可恢复，是否取消订单？</div>
                    {summary?.total ? (
                        <div className="mt-3 rounded bg-gray-100 p-4">
                            <div>
                                该订单有 <span className="text-red-500">{summary.total}</span>
                                个待处理项，订单取消以下内容会全部取消
                            </div>
                            <div>
                                <span className="font-medium">收款记录：</span>
                                <span className="text-red-500">{summary.pendingPaymentReceiveNum}</span>
                                个待支付，<span className="text-red-500">{summary.pendingConfirmReceiveNum}</span>
                                个待确认支付
                            </div>
                            <div>
                                <span className="font-medium">提货明细：</span>
                                <span className="text-red-500">{summary.toBeConfirmedDeliveryNum}</span>
                                个待确认，<span className="text-red-500">{summary.confirmedDeliveryNum}</span>
                                个已确认
                            </div>
                        </div>
                    ) : null}
                </div>
            ) : (
                <div>是否取消订单，取消后此订单作废</div>
            )}
        </ZhDialog>
    );
}

export default TradeOrderCancelDialog;
